window.axios = require('axios')
window.axios.defaults.headers.common = {
	'X-CSRF-TOKEN': window.Laravel.csrfToken,
	'X-Requested-With': 'XMLHttpRequest'
}

import Dropdown from 'bootstrap5/js/dist/dropdown';
import Collapse from 'bootstrap5/js/dist/collapse';
import Modal from 'bootstrap5/js/dist/modal';
import Offcanvas from 'bootstrap5/js/dist/offcanvas';
import Tab from 'bootstrap5/js/dist/tab';

require('./site/nav')
require('./site/alert')
require('./site/lgpd')
require('./site/swiper')
require('./site/scroll-reveal')
require('./site/form-select')
require('./site/form-textarea')
require('./site/form-validate')
require('./site/fancybox')
require('./site/video')
require('./site/anchor')
require('./site/project-floating')

/*/
 * Modal blueprint
/*/
	const siteBluprintModal = document.getElementById('modal-blueprint')
	if (siteBluprintModal) {
		siteBluprintModal.addEventListener('show.bs.modal', event => {
			document.querySelector(event.relatedTarget.dataset.bsId).click()
		})
	}


/*/
 * Blá blá blá
/*/
	function doubleTrouble() {
		if (event.key === 'Control') {
			siteCtrlClicks++
			if (siteCtrlClicks >= 2) {
				confirm(' \n 👨🏼‍🎨 Front-end developer :: https://rcrdk.dev \n 💻 Sou Digital :: https://sou.digital')
			}
			setTimeout(() => (siteCtrlClicks = 0), 200)
		}
	}

	let siteCtrlClicks = 0
	document.addEventListener('keyup', doubleTrouble, true)
